import { useIdentifiedListContext } from '../utils/IdentifiedListContext';
import CompanyNameFilter from './CompanyNameFilter';
import CountryFilter from './CountryFilter';
import MatchScoreFilter from './MatchScoreFilter';
import ClearFiltersButton from '@/Pages/Candidates/components/ClearFiltersButton';
import UIStrings from '@/Utils/UIStrings';

const AdvancedFilters = () => {
    const { setOptions } = useIdentifiedListContext();

    const handleClearFilters = () => {
        setOptions((p) => ({
            ...p,
            search: p.search,
            matchScoreMin: undefined,
            matchScoreMax: undefined,
            companyId: undefined,
            country: undefined,
            regionPair: undefined,
        }));
    };

    return (
        <div className="flex items-center gap-1">
            <span className="text-muted-foreground text-xs font-bold">{`${UIStrings.Filter}:`}</span>
            <CompanyNameFilter />
            <CountryFilter />
            <MatchScoreFilter />
            <ClearFiltersButton data-cy="AdvancedFilterReset" onClick={handleClearFilters} />
        </div>
    );
};

export default AdvancedFilters;
